import {InjectionToken} from "@angular/core";

export const PRODUCT_STEP_COMPONENT_INPUT = new InjectionToken('PRODUCT_STEP_COMPONENT_INPUT');
export const TICKET_STEP_COMPONENT_INPUT = new InjectionToken('TICKET_STEP_COMPONENT_INPUT');
